/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col, ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import './Footer.css'

 const getFullYear = () => {
   const today = new Date();
   return today.getFullYear();
 }
const AppFooter = (props) => {
  const {value, dataId, params} = props;
  let displayName = '';

  const langDropDownList = params.languages.map(function (item, index) {
    const subEventKey = (index+1)*0.1;
    let clz = '';

    if ( item.i18n === params.currentLanguage) {
      clz = 'active';
      displayName = item.displayName;
    }

    return (
      <MenuItem
        key={item.i18n}
        data-key={'app.footer.languages'+index}
        eventKey={subEventKey}
        onClick={()=>{params.onLanguageDidChange(item.i18n)}}
        className={clz}
      >
        {item.displayName}
      </MenuItem>
    );
  });

  return (
    <footer data-id={ dataId }>
        <Grid>
            <Row>
                <Col sm={12} md={6} className="grid-nav">
                    <nav className="footer-nav">
                        <ButtonToolbar>
                            <DropdownButton
                              dropup
                              title={ displayName }
                              id="languageOption"
                              className={'language-option'}
                            >
                              { langDropDownList }
                            </DropdownButton>
                        </ButtonToolbar>

                    </nav>
                </Col>
                <Col sm={12} md={6} className="grid-copyright">
                    <article data-key={'app.footer.copyright'} className="copyright-content">
                      <FormattedMessage id="app.footer" 
                          defaultMessage={value.copyright}
                          values={{
                            year: getFullYear()
                          }}
                      />
                    </article>
                </Col>
            </Row>
        </Grid>
    </footer>
  )
};
AppFooter.propTypes = {
  value: PropTypes.object,
  dataId: PropTypes.string.isRequired,
};

export default AppFooter;


// WEBPACK FOOTER //
// ./src/shared/AppFooter/components/AppFooter.js